"use strict";

$(document).ready(function(){
	// mobile nav
    $('.header__nav--mobile').click(function(){
        $('.hamburger').toggleClass('is-active');
        if($('.hamburger').hasClass('is-active')){
			// $('body').css({'position' : 'fixed'});
			$('.header__nav').css({'display' : 'flex'});
			$('.header__nav--wrap').addClass('is-active');
        } else{
			// $('body').css({'position' : 'relative'});
			$('.header__nav').css({'display' : 'none'});
			$('.header__nav--wrap').removeClass('is-active');
        }
    });

	// learn deck
	$('#learn-btn').click(function(){
		$('.learn__deck span').slideToggle();
	});

	// learn cards
	$(window).scroll(function(){
		var topDivHeight = $('.learn__card').height();
		var viewPortSize = $(window).height();

		var triggerAt = 150;
		var triggerHeight = (topDivHeight - viewPortSize) + triggerAt;

		if($(window).scrollTop() >= triggerHeight){
			$('.learn__card').css('visibility', 'visible').hide().fadeIn();
			$(this).off('scroll');
		}
	});

	// media filter
	$('[name="filter"]').change(function(){
		var url = $(this).val();
		window.location.href = url;
	});
	
	// lity
	$('.wp-block-image img').attr('data-lity', '');
	$('.wp-block-timeline img').attr('data-lity', '');

	// aos
	AOS.init({
		easing: 'ease',
		duration: 1500
	});

	// anchors
	$(function(){
		$('a[href*="#"]:not([href="#"])').click(function(){
			if(location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname){
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if(target.length){
					$('html, body').animate({
						scrollTop: target.offset().top - 100
					}, 1000);
					return false;
				}
			}
		});
	});
});